module.exports = __webpack_public_path__ + "img/ferrous-shadow.17287ac1.webp";